import {
  WebsiteLayout,
  ContactUsForm,
  GeneralInformationCard,
  Mailbox,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  TalentNewsletterSections,
  WebsiteSeo,
} from '@platform/website-components'
import { ReactElement, useRef } from 'react'

import styles from './index.module.scss'

const SEO = {
  title: 'Contact us // Olby',
  description: 'Have any questions? We’ll be happy to help you.',
}

const ContactUs = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null)
  const newsletterRef = useRef<HTMLElement | null>(null)

  useUpdateHeader(sectionRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useUpdateHeader(newsletterRef, HEADER_THEMES.EXT_DEEP_BLUE)
  useCleanHeader()

  return (
    <>
      <div className={styles['wrapper']} ref={sectionRef}>
        <WebsiteSeo seo={SEO} />
        <div className={styles['content-wrapper']}>
          <h1 className={styles['title']}>Contact us</h1>
          <p className={styles['description']}>We’ll be happy to help you.</p>
          <div className={styles['content']}>
            <div className={styles['picture']}>
              <Mailbox className={styles['icon']} />
            </div>
            <ContactUsForm className={styles['form']} />
            <GeneralInformationCard className={styles['card']} />
          </div>
        </div>
      </div>
      <TalentNewsletterSections ref={newsletterRef} />
    </>
  )
}

export default ContactUs

ContactUs.getLayout = (page: ReactElement) => {
  return (
    <WebsiteLayout shouldChangeBgColor headerInitialTheme={HEADER_THEMES.NEUTRAL_BACKGROUND}>
      {page}
    </WebsiteLayout>
  )
}
